import { render, staticRenderFns } from "./PlaylistCreatedDialog.vue?vue&type=template&id=afd4e570&scoped=true&"
import script from "./PlaylistCreatedDialog.vue?vue&type=script&lang=js&"
export * from "./PlaylistCreatedDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistCreatedDialog.vue?vue&type=style&index=0&id=afd4e570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd4e570",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCol,VDialog,VRow})
